/**
 * API 엔드포인트 정의
 * 모든 API 경로를 중앙에서 관리하여 변경 시 한 곳에서만 수정하도록 합니다.
 */

// 시설 관련 엔드포인트
export const poolEndpoints = {
  getAll: '/api/pools',
  getByCode: (code: string) => `/api/pools/code/${code}`,
  getById: (id: number) => `/api/pools/${id}`,
  create: '/api/pools',
  update: (id: number) => `/api/pools/${id}`,
  delete: (id: number) => `/api/pools/${id}`,
  getByCodeEquipment: (code: string) => `/api/equipment/by-code/${code}`,
};

// CCTV 관련 엔드포인트
export const cctvEndpoints = {
  getAll: (poolId: number) => `/api/pools/${poolId}/cctvs`,
  getById: (poolId: number, cctvId: number) => `/api/pools/${poolId}/cctvs/${cctvId}`,
  create: (poolId: number) => `/api/pools/${poolId}/cctvs`,
  update: (poolId: number, cctvId: number) => `/api/pools/${poolId}/cctvs/${cctvId}`,
  delete: (poolId: number, cctvId: number) => `/api/pools/${poolId}/cctvs/${cctvId}`,
};

// 웨어러블 관련 엔드포인트
export const wearableEndpoints = {
  getAll: (poolId: number) => `/api/pools/${poolId}/wearables`,
  getById: (poolId: number, wearableId: number) => `/api/pools/${poolId}/wearables/${wearableId}`,
  create: (poolId: number) => `/api/pools/${poolId}/wearables`,
  update: (poolId: number, wearableId: number) => `/api/pools/${poolId}/wearables/${wearableId}`,
  delete: (poolId: number, wearableId: number) => `/api/pools/${poolId}/wearables/${wearableId}`,
}; 